import { render, staticRenderFns } from "./DateNow.vue?vue&type=template&id=e68c4044&scoped=true"
import script from "./DateNow.vue?vue&type=script&lang=js"
export * from "./DateNow.vue?vue&type=script&lang=js"
import style0 from "./DateNow.vue?vue&type=style&index=0&id=e68c4044&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68c4044",
  null
  
)

export default component.exports